module.exports = emuiDiagnostics;